// extracted by mini-css-extract-plugin
export default {"addLangButton":"AddLangButton_addLangButton__0UoS+","langDropDownWrap":"AddLangButton_langDropDownWrap__SaRXZ"};